export { AnimalLookupDialogModule } from './lib/animal-lookup-dialog.module';
export { AnimalLookupDialogService } from './lib/animal-lookup-dialog.service';
export type {
  AnimalInfoDialogParams,
  AnimalLookupDialogParams,
  RvoRouteMapDialogParams
} from './lib/animal-lookup-dialog.service';
